import {Component, DestroyRef, inject, Input, OnInit, ViewEncapsulation} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import {combineLatestWith, Observable} from 'rxjs';
import {filter, map, tap, withLatestFrom} from 'rxjs/operators';
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {LocationSetTypesFacadeService} from '@emm/management/services/location-set-types-facade.service';
import {OperatorLocksFacadeService} from '@emm/management/services/operator-locks-facade.service';
import {NotificationService} from '@emm/shared/services/notification.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-operator-locks-form',
    templateUrl: './operator-locks-form.component.html',
    styleUrls: ['./operator-locks-form.component.scss'],
    standalone: false
})
export class OperatorLocksFormComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);
    form;
    @Input() isSuperAdmin: boolean;
    @Input() isAdmin: boolean;
    @Input() isAuthor: boolean;
    canEdit: boolean;
    emergencyDetail$ = this.operatorLocksFacadeService.emergencyItemDetail$;
    model = {};
    pipe = new DatePipe('en-US');

    model$ = this.emergencyDetail$.pipe(
        filter(RA.isNotNil),
        map((emergencyDetail: any) => (this.form = this.formBuilder.group({
            subType: [emergencyDetail.subType, {disabled: true, nonNullable: true }],
            statusMessage: [emergencyDetail.statusMessage, {disabled: false }],
            active: [emergencyDetail.active === true, {disabled: false, nonNullable: true }],
        })))
    );

    constructor(
        private authFacade: AuthFacadeService,
        private locationSetTypesFacade: LocationSetTypesFacadeService,
        private operatorLocksFacadeService: OperatorLocksFacadeService,
        private notificationService: NotificationService,
        private formBuilder: FormBuilder
    ) {
    }


    ngOnInit(): void {
        this.canEdit = this.isSuperAdmin || this.isAdmin || this.isAuthor;
        this.model$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            if (!this.canEdit) {
                this.form.disable();
            }
        });
    }


    cancel(): void {
        this.emergencyDetail$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(emergencyDetail =>
            this.model = emergencyDetail);
        this.form.reset(this.model);
    }


    submit(emergencyStatusTag: string, reloadAfterUpdate: boolean = true): void {

        const statusMessage = this.form.controls.statusMessage.value ? this.form.controls.statusMessage.value : '';
        const active = this.form.controls.active.value;
        const subType = this.form.controls.subType.value;
        this.operatorLocksFacadeService.api
            .updateStatus(emergencyStatusTag, statusMessage, active, subType)
            .pipe(withLatestFrom(this.emergencyDetail$), takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: ([success, emergencyDetail]) => {
                    if (success) {
                        this.notificationService.success(`Successfully updated ${emergencyDetail.name}. Please Refresh the tree.`);
                    }
                },
                error: ([error, emergencyDetail]) => {
                    this.notificationService.error(error?.error?.error?.message ||
                        `Failed to update ${emergencyDetail.name}`);
                }
            });
    }


    hasChanges(): boolean {
        return this.form && this.form.dirty;
    }


    isFormReady(): boolean {
        return this.form && this.form.dirty && !this.form.invalid;
    }


}
